/**
 * 注文オプションの編集モード（ADR-0076）。
 *
 * 管理画面の「オプションを編集」から
 *   /products/<handle>?edit_order=<注文名>&edit_line=<line_item_id>&edit_token=<署名>
 * で着地したときだけ動く。本注文フォームをそのまま使い、**カートに入れる代わりに**
 * 組み上がったプロパティ一式をバックエンドへ保存する。
 *
 * 🔴 なぜフォームを作り直さないか
 *   段階解錠・相互制約（加工→用紙の絞り込み、光沢紙×木製パネルの停止 等）は
 *   rf-base-form.js + rf-custom-form.js の約8,800行にある。管理画面側に写すと
 *   必ずズレる（2026-08-31 に「同じ判定を2箇所に書いた」事故を2件踏んでいる）。
 *   条件の正本は1つに保つ。
 *
 * 🔴 カートへ入る事故の塞ぎ方
 *   `cart/add` の呼び出しは実測で3経路ある（rf-base-form.js:1578 / rf-custom-form.js:3847 /
 *   rf-base-form.js:1066 の native form action）。個別に潰すと**隣の行**を取り逃すので、
 *   ここでは経路ごと塞ぐ:
 *     ① fetch を包んで cart/* を通さない（= payload の横取り口も兼ねる）
 *     ② submit イベントを capture で捕まえ、native 送信を止める
 *     ③ form.action を書き換えて、JS が死んでも素の POST が飛ばないようにする
 *   ①が本線、②③は本線が壊れた時の保険。**保険だけにしない**。
 */
(function () {
  'use strict';

  var q = new URLSearchParams(location.search);
  var ORDER = (q.get('edit_order') || '').trim();
  var LINE = (q.get('edit_line') || '').trim();
  if (!ORDER || !LINE) return;                 // 通常の商品ページでは何もしない

  // 🔴 order-print.muog.co.jp は Shopify アプリの application_url(Xserver)で、
  //    ここの API は載っていない(2026-09-01 実測: /pa-edit-state が 404)。
  //    編集モードの3ルートは Cloud Run の gmail-addon-order-lookup にある。
  //    管理画面拡張(OrderPaEdit.jsx)と同じ URL を使う。
  var BACKEND = 'https://gmail-addon-order-lookup-199163109979.asia-northeast1.run.app';
  var SAVE_URL = BACKEND + '/pa-override-from-form';
  var STATE_URL = BACKEND + '/pa-edit-state';
  var SESS_KEY = 'photopri:edit:session';
  var PREFILL_KEY = 'photopri:reorder:prefill';   // 再注文の復元機構と同じ口を使う
  // カート追加を断る 422 の description。フォームの alert を握る目印も兼ねるので1か所で持つ。
  var EDIT_MODE_DESC = '編集モードではカートに追加しません';

  // 🔴 復元は作らずに再注文の reorder-prefill.js に任せる。あれは
  //    「値を差し込まずフォームを操作し、選べない状態なら当てず、最後に
  //     当たらなかった項目を出す」正しい実装で、条件を二重管理しないため。
  //    ただし読むのは sessionStorage で、**こちらの取得(非同期)より先に走る**。
  //    そこで2段構えにする:
  //      1回目 … token で現在値を取り、sessionStorage に置いて **URLからtokenを消して**再読込
  //      2回目 … reorder-prefill が復元し、この画面は保存だけを担う
  //    副次効果として、token がアドレスバー・履歴・Referer・解析スクリプトに残らない。
  function session() {
    try { return JSON.parse(sessionStorage.getItem(SESS_KEY) || 'null'); } catch (e) { return null; }
  }

  var urlToken = (q.get('edit_token') || '').trim();
  // 管理画面のリンクが付ける「元の明細のバリアント」(サイズ等)。テーマがサイズ選択で
  // URL を書き換える前に控え、1回目の読込でセッションにも残す。
  var URL_VARIANT = (q.get('variant') || '').trim();
  var sess = session();
  var TOKEN = (sess && sess.order === ORDER && sess.line === LINE) ? sess.token : '';
  if (!urlToken && !TOKEN) return;  // 無効な編集リンクで購入画面を塞がない
  var CART_RE = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;
  var saved = false;
  var remarksObserverAttached = false;

  // 🔴 カート追加は下の fetch の包みが 422 で断る。フォームはそれを
  //    「カートへの追加に失敗しました」と alert するため、確認の表の上に失敗の文言が
  //    重なり、保存できていないように見えていた(2026-10-20 砂田さんの録画)。
  //    自分で返した文言を含む alert だけを握り、ほかの alert は通す。
  var origAlert = window.alert;
  window.alert = function (msg) {
    if (String(msg == null ? '' : msg).indexOf(EDIT_MODE_DESC) >= 0) return;
    return origAlert.apply(window, arguments);
  };

  function unhideRemarks() {
    var el = document.getElementById('rf-file-remarks-group');
    if (el && el.style.display === 'none') {
      // 🔴 CSS だけでは足りない。getProperties() は style 属性の文字列を見て
      //    display:none の内側にあるプロパティを送信対象から外すため、属性自体を外す。
      el.style.removeProperty('display');
    }
  }

  function observeRemarks() {
    if (remarksObserverAttached) return;
    var el = document.getElementById('rf-file-remarks-group');
    if (!el) return;
    remarksObserverAttached = true;
    unhideRemarks();
    new MutationObserver(function () {
      // 🔴 removeProperty 後にも通知は来るが、その時 display は空なので何も書かず、輪にならない。
      unhideRemarks();
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  // 🔴 備考は元の注文にある大事なプロパティ。ファイル欄だけを隠し、テーマの
  //    inline display:none より強く備考を出して、復元ポーラが始まる前に操作可能にする。
  function installEditFormUi() {
    if (!document.getElementById('rf-edit-form-style')) {
      var style = document.createElement('style');
      style.id = 'rf-edit-form-style';
      style.textContent = '#rf-file-remarks-group{display:block!important}'
        + '#rf-section-upload .rf-upload-row,#rf-section-upload #rf-file-list, '
        + '#rf-section-upload #rf-upload-error{display:none!important}';
      document.head.appendChild(style);
    }
    var section = document.getElementById('rf-section-upload');
    if (section && !section.querySelector('#rf-edit-upload-note')) {
      var note = document.createElement('p');
      note.id = 'rf-edit-upload-note';
      note.textContent = '入稿データは元の注文のままです（この画面では差し替えません）';
      var row = section.querySelector('.rf-upload-row');
      if (row && row.parentNode) row.parentNode.insertBefore(note, row);
      else section.insertBefore(note, section.firstChild);
    }
    var btn = document.getElementById('rf-add-to-cart');
    if (btn) {
      // 🔴 rf-base-form は cloneNode 後に rfOriginalText を復元先として使う。
      //    差し替えの前後どちらで boot しても、clone に編集用の控えを引き継ぐ。
      btn.dataset.rfOriginalText = '変更内容を確認する';
      if (btn.textContent !== '変更内容を確認する') btn.textContent = '変更内容を確認する';
    }
  }

  // 🔴 rf-base-form の復元先を編集用文言にする。DOM 監視で書き戻すと
  //    自分の textContent 更新が observer を再発火させるため監視しない。
  function keepEditButtonLabel() {
    installEditFormUi();
  }

  // 🔴 復元側は一般注文向けの文面を使う。既知の文だけ編集時に置き換え、
  //    変更後の未知の文面には触れず、通常ページの表示にも影響させない。
  function wrapRestoreMessages() {
    var modal = window.RFModal;
    if (modal && typeof modal.alert === 'function' && !modal.alert.__rfEditWrapped) {
      var original = modal.alert;
      var wrapped = function (title, body) {
        var changed = String(body || '')
          .replace('前回のご注文内容を反映しました。', '元の注文の内容を反映しました。')
          .replace('次の項目は<strong>現在お選びいただけないため、反映していません</strong>。',
            '次の項目は、今のフォームでは選べないため反映していません。')
          .replace('お手数ですが、あらためてお選びください。', '選び直してから保存してください。');
        return original.call(this, title, changed);
      };
      wrapped.__rfEditWrapped = true;
      modal.alert = wrapped;
    }
    var note = document.getElementById('reorder-prefill-note');
    if (note) {
      var changed = note.textContent
      .replace('前回のご注文内容を反映しました。', '元の注文の内容を反映しました。')
      .replace('次の項目は反映していません：', '次の項目は、今のフォームでは選べないため反映していません：')
      .replace('次の項目は現在お選びいただけないため反映していません',
        '次の項目は、今のフォームでは選べないため反映していません')
      .replace('前回のご注文内容を反映できませんでした。', '元の注文の内容を反映できませんでした。')
      .replace('あらためてお選びください。', '選び直してから保存してください。')
      .replace('お手数ですが、選び直してから保存してください。', '選び直してから保存してください。');
      if (changed !== note.textContent) note.textContent = changed;
    }
  }

  function overlay(html, isError) {
    var el = document.getElementById('rf-edit-overlay') || document.createElement('div');
    el.id = 'rf-edit-overlay';
    el.setAttribute('style', 'position:fixed;inset:0;z-index:1000001;background:rgba(255,255,255,.97);'
      + 'display:flex;align-items:center;justify-content:center;padding:1.5rem;text-align:center;'
      + 'font-family:inherit;line-height:1.8');
    // 🔴 差分が多い/長いと、固定表示のままではボタンが画面外へ出て確認も取消も
    //    できなくなる。中身側をスクロールさせる。
    el.innerHTML = '<div style="max-width:32rem;width:100%;max-height:calc(100vh - 3rem);'
      + 'overflow:auto">' + html + '</div>';
    if (!el.parentElement) document.body.appendChild(el);
    if (isError) el.style.background = 'rgba(255,247,247,.98)';
  }

  function closeOverlay() {
    var el = document.getElementById('rf-edit-overlay');
    if (el && el.parentElement) el.parentElement.removeChild(el);
  }

  /** 閉じられるエラー表示。
   *
   * 🔴 全画面のオーバーレイを閉じられないまま出すと、下の「カートに追加」を
   *    押せなくなり、やり直す手段が無くなる(通信エラーや読み込み待ちの
   *    タイムアウトは、待てば直る類なので特にまずい)。
   */
  function errorOverlay(html) { closableOverlay(html, true); }

  /** 閉じられる案内(エラーではない)。閉じればフォームに戻って直せる。 */
  function noticeOverlay(html) { closableOverlay(html, false); }

  function closableOverlay(html, isError) {
    overlay(html + '<div style="margin-top:1rem"><button type="button" id="rf-edit-close" '
      + 'style="padding:.6rem 1.2rem;background:#fff;color:#111;border:1px solid #ccc;'
      + 'border-radius:4px;cursor:pointer">閉じる</button></div>', isError);
    var b = document.getElementById('rf-edit-close');
    if (b) b.addEventListener('click', closeOverlay);
  }

  function banner() {
    var b = document.createElement('div');
    b.setAttribute('style', 'position:sticky;top:0;z-index:9998;background:#111;color:#fff;'
      + 'padding:.7rem 1rem;font-size:.85rem;line-height:1.6;text-align:center;'
      + 'display:flex;gap:.8rem;align-items:center;justify-content:center;flex-wrap:wrap');
    var t = document.createElement('span');
    // 🔴 textContent で入れる。ORDER は URL 由来なので innerHTML に混ぜない。
    t.textContent = 'ご注文 ' + ORDER + ' の内容を変更しています。'
      + 'この画面ではカートに入りません。保存は最後の確認を押した時だけです。';
    var q = document.createElement('button');
    q.type = 'button';
    q.textContent = '編集をやめる';
    q.setAttribute('style', 'padding:.35rem .9rem;background:transparent;color:#fff;'
      + 'border:1px solid #fff;border-radius:4px;cursor:pointer;font-size:.8rem;'
      + 'white-space:nowrap');
    // 🔴 「閉じていい」と分かる出口を置く。無いと、やめたい人が保存を押して確かめる。
    q.addEventListener('click', function () {
      try { sessionStorage.removeItem(SESS_KEY); sessionStorage.removeItem(PREFILL_KEY); } catch (e) {}
      overlay('<p><strong>編集をやめました。</strong></p>'
        + '<p style="font-size:.9rem">ご注文の内容は変更していません。'
        + 'このタブを閉じて、管理画面に戻ってください。</p>'
        + '<p style="font-size:.8rem;color:#666">同じリンクからもう一度開けます。</p>');
      window.close();   // 別タブで開かれていれば閉じる(閉じられなければ上の案内が残る)
    });
    b.appendChild(t); b.appendChild(q);
    if (document.body.firstChild) document.body.insertBefore(b, document.body.firstChild);
    else document.body.appendChild(b);
  }

  /** 組み上がったカート payload から、この明細(本体)の行を取り出す。 */
  function mainItemFromCartPayload(payload) {
    var items = (payload && (payload.items || (payload.id ? [payload] : []))) || [];
    for (var i = 0; i < items.length; i++) {
      var p = items[i] && items[i].properties;
      // 🔴 _bundle_type=main の明細だけを見る。用紙・加工は別明細としてぶら下がるので、
      //    先頭を無条件に採ると加工側のプロパティを本体の内容として保存してしまう。
      if (p && (p._bundle_type === 'main' || items.length === 1)) return items[i];
    }
    return items[0] || null;
  }

  // 復元の結果。reorder-prefill.js が復元し終えた瞬間だけ確定する。
  var restoreDone = null;
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  var pendingSave = null;                      // 復元待ちで保留になった保存
  function adoptRestore(detail) {
    if (restoreDone) return;
    restoreDone = detail || { notSet: [] };
    // 🔴 復元中に押された保存を拾い直す。エラーを出したまま放置すると、
    //    復元用の sessionStorage はもう消費済みなので、再読込でも復帰できない。
    if (pendingSave) { var p = pendingSave; pendingSave = null; save(p.props, p.variant); }
  }
  document.addEventListener('photopri:reorder-prefill:done', function (ev) {
    adoptRestore(ev && ev.detail);
  });
  // このファイルが復元より後に読まれた場合。イベントはもう飛んでいるので window から拾う。
  if (window.__photopriReorderPrefill) adoptRestore(window.__photopriReorderPrefill);

  /** 送信内容を注文の元の内容と突き合わせ、変わる項目を並べる。
   *
   * 🔴 「人が意図した変更か」を機械に推測させない。復元が静かに失敗した状態を
   *    そのまま保存させないことが目的だが、意図の推定はどこまでやっても外れる:
   *      - `用紙種類` の option.value は英語 handle で、注文に入るのは表示名
   *      - `加工種別` は `input[name="rf-processing-type"]` から作られ、
   *        `properties[加工種別]` という部品自体が存在しない
   *      - 木製パネル/スチレンでは `フレームカラー` が `側面テープ(カラー)` に化ける
   *      - ピル型ウィジェットは合成イベントで値を入れる(isTrusted=false)
   *    そこで**変わる内容を人に見せて確認させる**。判定に使うのは
   *    「フォームが組み上げた送信内容」と「注文の元の内容」だけで、対応表も
   *    イベントの信頼性判定も要らない。
   */
  function normv(v) {
    // 🔴 空白は潰さない。潰すと "1行目\n2行目" と "1行目 2行目" が同じに見え、
    //    改行が消えた事故を「変更なし」として素通りさせる。
    return String(v == null ? '' : v).replace(/\r\n?/g, '\n').trim();
  }

  function diffAgainstOrder(props) {
    var sess = session();
    var want = (sess && sess.expected) || null;
    if (!want) return null;                     // 期待値が無い = 検算できない
    // 復元するものが無い明細では reorder-prefill が走らない(完了イベントも出ない)。
    // ここで待つと永久に保存できなくなる。
    if (Object.keys(want).length &&
        !restoreDone && !window.__photopriReorderPrefill) return null;
    var got = props || {};
    var keys = Object.keys(want).slice();
    Object.keys(got).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); });
    var rows = [];
    keys.forEach(function (k) {
      var ea = has(want, k), eb = has(got, k);
      var a = ea ? normv(want[k]) : '';
      var b = eb ? normv(got[k]) : '';
      // 🔴 「キーが無い」と「空文字」は別物。同じに畳むと、値が空の項目が
      //    黙って消える(サーバは props に無いキーを削除として扱う)。
      if (ea === eb && a === b) return;
      rows.push({ key: k, before: a, after: b, beforeExists: ea, afterExists: eb });
    });
    return rows;
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function diffHtml(rows) {
    return '<table style="width:100%;border-collapse:collapse;font-size:.85rem;text-align:left">'
      + '<tr><th style="padding:.3rem .5rem;border-bottom:1px solid #ddd">項目</th>'
      + '<th style="padding:.3rem .5rem;border-bottom:1px solid #ddd">変更前</th>'
      + '<th style="padding:.3rem .5rem;border-bottom:1px solid #ddd">変更後</th></tr>'
      + rows.map(function (r) {
        var cell = 'padding:.3rem .5rem;border-bottom:1px solid #f0f0f0;overflow-wrap:anywhere';
        var before = !r.beforeExists ? '（なし）' : (r.before === '' ? '（空）' : esc(r.before));
        var after = !r.afterExists ? '（削除）' : (r.after === '' ? '（空）' : esc(r.after));
        return '<tr><td style="' + cell + '">' + esc(r.key)
          + '</td><td style="' + cell + ';color:#888">' + before
          + '</td><td style="' + cell + ';font-weight:600">' + after + '</td></tr>';
      }).join('') + '</table>';
  }

  /** 元の明細のバリアント。1回目の読込で控えた値を優先する(2回目は URL が変わりうる)。 */
  function originalVariant() {
    // 🔴 URL の variant は種類を選び直すとテーマが書き換える。1回目の読込で
    //    控えた値だけを元の値とする(控えの無い旧セッションは「分からない」)。
    var s = session();
    return String((s && s.variant) || '');
  }

  function variantLabel(id) {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var vs = (meta && meta.product && meta.product.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(id)) return vs[i].public_title || vs[i].name || String(id);
      }
    } catch (e) { /* 表示名が引けなければ ID で出す */ }
    return String(id);
  }

  /** バリアントが元の明細と違えば {before, after}。
   *
   * 🔴 保存先(/pa-override-from-form)が持つのはプロパティだけで、サイズなど
   *    バリアントで決まる変更は保存されない。黙って落とさず、確認の画面で見せる。
   */
  function variantChange(variantId) {
    var before = originalVariant();
    var after = String(variantId == null ? '' : variantId);
    if (!after || before === after) return null;
    if (!before) return { unknown: true };
    return { before: variantLabel(before), after: variantLabel(after) };
  }

  function variantNoteHtml(vc) {
    if (vc.unknown) {
      return '<p style="font-size:.85rem;color:#b00020;text-align:left;margin-top:.8rem">'
        + 'サイズなど商品の種類を変えた場合、その変更はこの画面では保存されません。'
        + 'サイズを変える時は、管理画面のプロパティ編集でこの明細を「差し替え」てください。</p>';
    }
    return '<p style="font-size:.85rem;color:#b00020;text-align:left;margin-top:.8rem">'
      + 'サイズなど商品の種類が「' + esc(vc.before) + '」から「' + esc(vc.after) + '」に'
      + '変わっていますが、この画面では保存されません。サイズを変える時は、'
      + '管理画面のプロパティ編集でこの明細を「差し替え」てください。</p>';
  }

  function save(props, variantId) {
    if (saved) return;
    var want0 = (session() || {}).expected || null;
    var clean = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k.charAt(0) === '_') return;         // Shopify 内部用は編集対象にしない
      var v = props[k] == null ? '' : String(props[k]);
      // 🔴 空の項目は原則送らない(Shopify も空のプロパティを持たない)。
      //    ただし**元の注文にそのキーがある**場合だけは送る。落とすと差分表に
      //    「（空）→（削除）」と出るのに、フォームからは直しようがない項目になる。
      if (!v.trim() && !(want0 && has(want0, k))) return;
      clean[k] = v;
    });
    var rows = diffAgainstOrder(clean);
    if (rows === null) {
      pendingSave = { props: props, variant: variantId };   // 復元が終わったら自動で続きをやる
      overlay('<p><strong>編集前の内容を読み込んでいます…</strong></p>'
        + '<p style="font-size:.85rem">読み込みが終わり次第、確認画面を出します。</p>');
      setTimeout(function () {
        if (!pendingSave) return;
        pendingSave = null;
        errorOverlay('<p><strong>編集前の内容を復元できませんでした。</strong></p>'
          + '<p style="font-size:.85rem">保存せずにこの画面を閉じ、'
          + '管理画面から開き直してください。</p>');
      }, 12000);
      return;
    }
    var vc = variantChange(variantId);
    if (rows.length) { confirmThenSave(clean, rows, vc); return; }
    // 🔴 変わる項目が0件なら保存しない。以前は確認を飛ばしてそのまま保存しており、
    //    サイズだけ変えた時に「保存しました」と出て何も変わらず、一度きりの編集リンクまで
    //    使い切っていた(2026-10-20 #P36502・カード 86527ba3)。
    noticeOverlay('<p><strong>変更された項目はありません。保存していません。</strong></p>'
      + (vc ? variantNoteHtml(vc)
            : '<p style="font-size:.85rem">閉じてフォームを直すか、このタブを閉じて管理画面に戻ってください。</p>'));
  }

  /** 変わる項目を見せて、人に確認させてから保存する。
   *
   * 🔴 これが「復元に失敗していないか」の最後の砦。機械が意図を推測するのをやめ、
   *    **変わる内容そのもの**を出して人に判断させる。復元が静かに失敗していれば、
   *    触っていない項目がこの表に並ぶので気づける。
   */
  function confirmThenSave(clean, rows, vc) {
    overlay('<p><strong>この内容でご注文を更新します。</strong></p>'
      + diffHtml(rows)
      + (vc ? variantNoteHtml(vc) : '')
      + '<p style="font-size:.8rem;color:#666;margin-top:.8rem">'
      + '触っていない項目がこの表に出ている場合は、元の内容を復元できていません。'
      + '保存せずに画面を閉じ、管理画面から開き直してください。</p>'
      + '<div style="margin-top:1rem;display:flex;gap:.6rem;justify-content:center">'
      + '<button type="button" id="rf-edit-confirm" style="padding:.7rem 1.4rem;'
      + 'background:#111;color:#fff;border:0;border-radius:4px;cursor:pointer">'
      + 'この内容で保存する</button>'
      + '<button type="button" id="rf-edit-cancel" style="padding:.7rem 1.4rem;'
      + 'background:#fff;color:#111;border:1px solid #ccc;border-radius:4px;cursor:pointer">'
      + 'やめる</button></div>');
    var okBtn = document.getElementById('rf-edit-confirm');
    var noBtn = document.getElementById('rf-edit-cancel');
    if (okBtn) okBtn.addEventListener('click', function () { doSave(clean); });
    if (noBtn) noBtn.addEventListener('click', closeOverlay);
  }

  function doSave(clean) {
    if (saved) return;
    saved = true;
    overlay('<p>保存しています…</p>');
    fetch(SAVE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order: ORDER, line_item_id: LINE, token: TOKEN,
                            digest: (session() || {}).digest || '', props: clean })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      if (!res.ok || !res.d || res.d.ok !== true) {
        saved = false;
        var why = (res.d && (res.d.reason || res.d.error)) || 'unknown';
        errorOverlay('<p><strong>保存できませんでした。</strong></p>'
          + '<p style="font-size:.85rem;color:#666">理由: ' + esc(why) + '</p>'
          + '<p style="font-size:.85rem">この画面を閉じ、管理画面からやり直してください。</p>');
        return;
      }
      overlay('<p><strong>保存しました。</strong></p>'
        + '<p style="font-size:.9rem">ご注文 ' + esc(ORDER) + ' の内容を更新しました。'
        + 'このタブを閉じて、管理画面に戻ってください。</p>'
        + '<p style="font-size:.8rem;color:#666">指示書には反映されます。'
        + 'レイアウト作成済みの場合、レイアウトは作り直されません。</p>');
    }).catch(function (e) {
      saved = false;
      errorOverlay('<p><strong>保存できませんでした（通信エラー）。</strong></p>'
        + '<p style="font-size:.85rem;color:#666">' + esc(e) + '</p>');
    });
  }

  // ① fetch を包む。cart/* は**通さない**。payload はここで横取りする。
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    // 🔴 string / URL / Request の3通りを正規化してから見る。
    //    `fetch(new URL('/cart/add.js', location.origin))` は string でも
    //    Request でもないため、素朴な判定だと**素通りして実カートに入る**。
    var url = '';
    try {
      var raw = (typeof input === 'string') ? input
        : (input && typeof input.url === 'string') ? input.url
        : (input && typeof input.href === 'string') ? input.href
        : String(input || '');
      url = new URL(raw, location.href).pathname;
    } catch (e) { url = ''; }
    if (CART_RE.test(url)) {
      var payload = null;
      try {
        var body = (init && init.body) || (input && input.body);
        if (typeof body === 'string') payload = JSON.parse(body);
      } catch (e) { payload = null; }
      var item = mainItemFromCartPayload(payload);
      var props = item && item.properties;
      if (props) {
        save(props, item.id);
      } else {
        overlay('<p><strong>編集内容を取り出せませんでした。</strong></p>'
          + '<p style="font-size:.85rem">お手数ですが、管理画面からやり直してください。</p>', true);
      }
      // フォーム側には「失敗」を返す。成功を返すと、カートに入った前提で
      // 入稿状態を消す後始末(resetAfterAddToCart)が走る。
      return Promise.resolve(new Response(
        JSON.stringify({ status: 422, message: 'edit-mode', description: EDIT_MODE_DESC }),
        { status: 422, headers: { 'Content-Type': 'application/json' } }));
    }
    return origFetch.apply(this, arguments);
  };

  // ①' fetch 以外の送信経路も塞ぐ。fetch だけ包んでも、別アプリやテーマ標準が
  //     XHR / sendBeacon を使えばそのまま実カートに入る（セカオピ指摘・2026-08-31）。
  //     ここは**横取りせず単に落とす**。カートに入れる意図の通信は編集モードに存在しない。
  try {
    var XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype && XHR.prototype.open) {
      var origOpen = XHR.prototype.open;
      XHR.prototype.open = function (method, url) {
        var path = '';
        try { path = new URL(String(url || ''), location.href).pathname; } catch (e) { path = ''; }
        this.__rfBlocked = CART_RE.test(path);
        return origOpen.apply(this, arguments);
      };
      var origSend = XHR.prototype.send;
      XHR.prototype.send = function () {
        if (this.__rfBlocked) {
          console.warn('rf-edit-mode: XHR による cart 送信を止めました');
          return;                              // 送らない。onload も呼ばない
        }
        return origSend.apply(this, arguments);
      };
    }
  } catch (e) { /* 包めない環境でも本線(fetch)は生きている */ }

  if (navigator && typeof navigator.sendBeacon === 'function') {
    var origBeacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url) {
      var path = '';
      try { path = new URL(String(url || ''), location.href).pathname; } catch (e) { path = ''; }
      if (CART_RE.test(path)) {
        console.warn('rf-edit-mode: sendBeacon による cart 送信を止めました');
        return false;
      }
      return origBeacon.apply(null, arguments);
    };
  }

  // ①'' 動的チェックアウト(Shop Pay / 今すぐ購入)は cart を経由せず checkout へ直行する。
  //     包んだ fetch も submit も通らないので、**出さない**のが唯一の確実な手。
  function hideExpressCheckout() {
    var SEL = 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart,'
      + ' .shopify-payment-button, [data-shopify="payment-button"],'
      + ' a[href*="/checkout"], a[href$="/cart"]';
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('#rf-edit-overlay')) continue;
      nodes[i].setAttribute('data-rf-edit-hidden', '1');
      nodes[i].style.setProperty('display', 'none', 'important');
    }
  }

  // ② native 送信を capture で止める（JS 経路が変わっても素の POST を飛ばさない）
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    if (CART_RE.test(f.getAttribute('action') || '')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // ③ action 自体を潰す。①②が壊れても素の POST が /cart/add へ行かない。
  // 🔴 action を潰すのは **フォームが初期化された後**。
  //    custom-upload-form.js:73 が `form[action*="/cart/add"]` でフォームを探すので、
  //    先に潰すと CustomOrderForm が生成されず、編集モードでフォームが丸ごと死ぬ
  //    (2026-08-31 実測: data-rf-initialized が付かず RF ログ 0件。
  //     「カート通信0件」も、動いていないから0件だっただけだった)。
  function neutralize() {
    var forms = document.querySelectorAll('form[data-rf-initialized][action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].setAttribute('data-rf-original-action', forms[i].getAttribute('action') || '');
      // 🔴 `/cart/add` を**文字列として残す**。テーマ側もアプリ側も
      //    `form[action*="/cart/add"]` でフォームを探しており(custom-upload-form.js:73 /
      //    reorder-prefill.js の待機ポーラ)、消すと発見できず**復元が丸ごと動かない**。
      //    about: スキームなので素の POST は飛ばない。無害かつ発見可能にする。
      forms[i].setAttribute('action', 'about:blank#/cart/add-disabled-by-edit-mode');
    }
  }

  /** 1回目: 現在の内容を取り、復元用に置いてから token 抜きで読み直す。 */
  function bootstrapAndReload() {
    overlay('<p>ご注文の内容を読み込んでいます…</p>');
    fetch(STATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order: ORDER, line_item_id: LINE, token: urlToken })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      if (!res.ok || !res.d || res.d.ok !== true || !res.d.properties) {
        var why = (res.d && (res.d.reason || res.d.error)) || 'unknown';
        // 🔴 「使用済み」と「期限切れ」を同じ文言にしない。使用済みは待っても直らず、
        //    管理画面で作り直す以外に手が無い。
        var used = res.d && res.d.error === 'token_already_used';
        overlay('<p><strong>ご注文の内容を読み込めませんでした。</strong></p>'
          + '<p style="font-size:.85rem;color:#666">理由: ' + String(why).replace(/</g, '&lt;') + '</p>'
          + '<p style="font-size:.85rem">'
          + (used ? '編集リンクは一度保存すると使えなくなります。'
                  : '編集リンクの有効期限は30分です。')
          + '管理画面の「リンクを作り直す」から、もう一度開いてください。</p>', true);
        return;
      }
      try {
        sessionStorage.setItem(SESS_KEY, JSON.stringify(
          { order: ORDER, line: LINE, token: res.d.token || urlToken,
            // 編集を**始めた時点**の版。保存時にサーバへ返し、間に誰かが
            // 保存していれば 409 で止める。
            digest: res.d.digest || '',
            // 🔴 期待値の控え。reorder-prefill は読んだ時点で自分のキーを消すので、
            //    保存前の検算用にこちらでも持っておく。
            expected: res.d.properties,
            // 元の明細のバリアント。サイズ等の変更が保存されないことを確認画面で見せるため。
            variant: URL_VARIANT }));
        sessionStorage.setItem(PREFILL_KEY, JSON.stringify({ properties: res.d.properties }));
      } catch (e) {
        overlay('<p><strong>この端末では編集できません。</strong></p>'
          + '<p style="font-size:.85rem">プライベートブラウズを解除してお試しください。</p>', true);
        return;
      }
      var u = new URL(location.href);
      u.searchParams.delete('edit_token');     // token を履歴・Referer に残さない
      location.replace(u.toString());
    }).catch(function (e) {
      overlay('<p><strong>読み込めませんでした（通信エラー）。</strong></p>'
        + '<p style="font-size:.85rem;color:#666">' + String(e).replace(/</g, '&lt;') + '</p>', true);
    });
  }

  function boot() {
    keepEditButtonLabel();
    wrapRestoreMessages();
    // ダイアログ/帯が後から生成される場合だけ追跡する。値が既に置換済みなら
    // 再代入しないため observer の自身の変更がマイクロタスクの輪にならない。
    var messageObserver = new MutationObserver(function () {
      wrapRestoreMessages();
      var modalReady = window.RFModal && window.RFModal.alert && window.RFModal.alert.__rfEditWrapped;
      if (modalReady && document.getElementById('reorder-prefill-note')) messageObserver.disconnect();
    });
    messageObserver.observe(document.documentElement, { childList: true, subtree: true });
    banner();
    neutralize();
    // フォームは非同期に描画されるので、遅れて現れた form も潰す
    hideExpressCheckout();
    observeRemarks();
    new MutationObserver(function () {
      neutralize(); hideExpressCheckout();
      if (!remarksObserverAttached) observeRemarks();
    })
      .observe(document.documentElement, { childList: true, subtree: true });
    if (urlToken) { bootstrapAndReload(); return; }
    if (!TOKEN) {
      // 🔴 token が無い＝復元前か、期限切れ。**保存させない**。この状態で保存すると
      //    触っていない項目までフォームの初期値で上書きされる。
      overlay('<p><strong>編集を開始できません。</strong></p>'
        + '<p style="font-size:.85rem">管理画面の「オプションを編集」からもう一度開いてください。'
        + '（編集リンクの有効期限は30分です）</p>', true);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
